import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BreadCrumb from '../../../components/common/BreadCrumb';
import { TableResponsive } from '../../../components/common/TableResponsive';
import { useEnquiryList } from './EnquiryList/useEnquiryList';
import { getEnquiryColumns } from './EnquiryList/enquiryColumns';
import './EnquiryList/EnquiryList.css';

function Enquiry() {
    const {
        enquirys,
        districtList,
        selectedDistrict,
        setSelectedDistrict,
        isLoading,
        authData,
        handleEnquiryDelete,
        handleReport
    } = useEnquiryList();

    const columns = useMemo(
        () =>
            getEnquiryColumns({
                authData,
                enquirys,
                handleEnquiryDelete,
                handleReport
            }),
        [authData, enquirys, handleEnquiryDelete, handleReport]
    );

    return (
        <>
            <BreadCrumb title="Users" prevPage="Home" prevPath="/dashboard" />
            <Row>
                <Col xs={12}>
                    <Card className="shadow-sm border-0">
                        <CardHeader className="d-flex align-items-center justify-content-between flex-wrap gap-2 py-3 border-bottom bg-transparent">
                            {/* Title & Count Badge */}
                            <div>
                                <div className="d-flex align-items-center gap-2">
                                    <h5 className="card-title mb-0 fs-16 fw-semibold text-body">Enquiry List</h5>
                                    {!isLoading && (
                                        <span className="badge bg-soft-primary text-primary fs-11 px-2 py-0.5">
                                            {enquirys.length} Active
                                        </span>
                                    )}
                                </div>
                                <p className="text-muted fs-12 mb-0">Manage customer inquiries, visits, and active leads</p>
                            </div>

                            {/* District Filter & Add Enquiry */}
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {/* District Filter (User requested) */}
                                <div className="d-flex align-items-center gap-1.5">
                                    <span className="fs-12 text-muted fw-medium text-nowrap">
                                        <i className="ri-building-line me-1" />
                                        District:
                                    </span>
                                    <select
                                        className="form-select form-select-sm fs-12"
                                        style={{ width: 'auto', minWidth: '135px' }}
                                        value={selectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                    >
                                        <option value="all">All Districts</option>
                                        {districtList.map((dist) => (
                                            <option key={dist} value={dist}>
                                                {dist}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <Link
                                    to={'/create-enquiry'}
                                    className="btn btn-sm btn-soft-success add-btn waves-effect d-inline-flex align-items-center gap-1"
                                >
                                    <i className="ri-add-line align-bottom fs-15"></i>
                                    <span>Add Enquiry</span>
                                </Link>
                            </div>
                        </CardHeader>
                        <CardBody className="p-0 p-md-3">
                            <TableResponsive
                                isLoading={isLoading}
                                columns={columns}
                                data={enquirys}
                                noRecord="No Active Enquiries for Selected Filter"
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default Enquiry;